export default __webpack_public_path__ + "static/media/download-icon.d1cb3704.jpg";